/* ==========================================================================
   Addict Store – Active : transition entre les pages, en-tête au défilement
   et accordéons (version légère).
   ========================================================================== */
(() => {
  'use strict';

  const theme = window.theme || (window.theme = {});
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animationsOn = theme.animations !== false && !theme.designMode && !reduceMotion;

  /* ---------- Transition entre les pages ---------- */
  const setupPageTransition = () => {
    const overlay = document.querySelector('.page-transition');
    if (root.classList.contains('pt-enter')) {
      setTimeout(() => root.classList.remove('pt-enter'), 950);
    }
    if (!overlay || !theme.pageTransition || reduceMotion || theme.designMode) return;

    const shouldHandle = (link, event) => {
      if (event.defaultPrevented || event.button !== 0) return false;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
      if (!link.href || link.target === '_blank' || link.hasAttribute('download')) return false;
      if (link.matches('[data-no-transition], [data-quick-view], [data-facet-link], [data-modal-open]')) return false;
      if (link.matches('[data-cart-toggle]') && theme.cartType === 'drawer') return false;
      const href = link.getAttribute('href') || '';
      if (href.startsWith('#') || /^(mailto|tel|javascript|sms):/i.test(href)) return false;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return false;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;
      if (/\/(checkout|cart\/|account|admin)/.test(url.pathname)) return false;
      return true;
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link || !shouldHandle(link, event)) return;
      event.preventDefault();
      try { sessionStorage.setItem('as-transition', '1'); } catch (e) { /* navigation privée */ }
      root.classList.remove('pt-enter');
      overlay.classList.add('is-leaving');
      setTimeout(() => { window.location.href = link.href; }, 430);
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        overlay.classList.remove('is-leaving');
        root.classList.remove('pt-enter');
      }
    });
  };

  /* ---------- En-tête : suit le défilement (part avec la page, revient en remontant) ---------- */
  const setupHeader = () => {
    const header = document.querySelector('header-component.header-wrapper--sticky');
    if (!header || header.dataset.hideOnScroll !== 'true') return;
    const section = header.parentElement;
    let stickStart = 0;
    let height = 0;
    let lastY = window.scrollY;
    let offset = 0;
    let applied = -1;
    let ticking = false;

    const measure = () => {
      stickStart = 0;
      let prev = section.previousElementSibling;
      while (prev) { stickStart += prev.offsetHeight; prev = prev.previousElementSibling; }
      height = header.offsetHeight;
    };

    const update = () => {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      lastY = y;
      const keepVisible = document.body.classList.contains('is-locked')
        || header.querySelector('.nav__item:hover, .nav__item:focus-within, predictive-search.is-open');
      if (keepVisible || y <= stickStart) offset = 0;
      else offset = Math.min(height, Math.max(0, offset + delta), y - stickStart);
      if (offset !== applied) {
        applied = offset;
        section.style.transform = offset ? `translate3d(0, ${-offset}px, 0)` : '';
      }
    };

    // Un tiroir (menu mobile) ouvert doit se positionner par rapport à l'écran :
    // on retire tout décalage de l'en-tête dès que la page est verrouillée.
    new MutationObserver(() => {
      if (document.body.classList.contains('is-locked') && applied !== 0) {
        offset = 0;
        applied = 0;
        section.style.transform = '';
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  };

  /* ---------- Accordéons animés ---------- */
  const setupAccordions = () => {
    if (!animationsOn) return;
    document.addEventListener('click', (e) => {
      const summary = e.target.closest('details.accordion > summary, details.filter-group > summary, .mobile-nav details > summary');
      if (!summary) return;
      const details = summary.parentElement;
      const content = [...details.children].filter((c) => c !== summary);
      if (!content.length || details.classList.contains('is-animating')) return;
      e.preventDefault();
      const startHeight = details.offsetHeight;
      details.classList.add('is-animating');
      if (details.open) {
        const styles = getComputedStyle(details);
        const endHeight = summary.offsetHeight + parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
        const anim = details.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, { duration: 300, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        anim.onfinish = () => { details.open = false; details.classList.remove('is-animating'); };
      } else {
        details.open = true;
        const endHeight = details.offsetHeight;
        const anim = details.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, { duration: 380, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        anim.onfinish = () => details.classList.remove('is-animating');
      }
    });
  };

  const init = () => {
    setupPageTransition();
    setupHeader();
    setupAccordions();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
